import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedNumber } from 'react-intl';
import { Button, Row, Col, FormGroup, ControlLabel, FormControl, Panel, DropdownButton } from 'react-bootstrap';
import FormPriceNetGross from 'components/forms/FormPriceNetGross';
import FormInput from 'components/forms/FormInput';
import FormRichEditor from 'components/forms/FormRichEditor';
import { getNameInCurrentLanguage } from 'helpers/intl';

class FormItemManual extends React.Component {
  state = {
    name: '',
    price: 0,
    vat: 19, // percent
    quantity: 1,
    description: null,
  };

  componentDidMount = () => {
    const { dataToEdit } = this.props;
    if (dataToEdit !== undefined) {
      this.setInitData(dataToEdit);
    } else {
      this.setState({ description: '' });
    }
  };

  setInitData = data => {
    const { appIntl } = this.props;
    let name = typeof data?.name === 'object'
      ? getNameInCurrentLanguage(data?.name, appIntl)
      : data?.name;

    this.setState({
      name: name,
      price: data?.netPrice,
      description: data?.description,
      vat: data?.vatRate,
      quantity: data?.quantity,
    });
  };

  setName = (name, value) => {
    this.setState({ name: value });
  };

  setPrice = event => {
    this.setState({ price: Number(event.target.value) });
  };

  setPriceValue = value => {
    this.setState({ price: Number(value) });
  };

  setDescription = (name, value) => {
    this.setState({ description: value });
  };

  /**
   * Set VAT rate
   * selected in a DropdownButton bootstrap component
   * @param {?number} eventKey
   */
  setVat = eventKey => {
    this.setState({ vat: eventKey });
  };

  setQuantity = event => {
    this.setState({ quantity: Math.max(0, Number(event.target.value)) });
  };

  save = () => {
    const { onSave } = this.props;
    onSave({ ...this.state });
  };

  cancel = () => {
    const { onCancel } = this.props;
    onCancel();
  };

  render() {
    const {
      intl: { messages },
      user,
      vatRateOptions,
    } = this.props;

    const { name, price, vat, quantity, description, index } = this.state;
    const vatTitle = Number(vat) ? <FormattedNumber value={vat / 100} style="percent" /> : 'n/a';

    return (
      <>
        <Panel bsStyle="primary">
          <Panel.Heading>
            <Panel.Title componentClass="h3" bsClass="text-primary">
              {messages.manual_item_entry}
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row className="clearfix">
              <Col sm={12} md={12} lg={12}>
                <FormGroup controlId="formItemManual-name">
                  <FormInput
                    label={messages.name}
                    name="name"
                    value={name}
                    onChange={(name, value) => {
                      this.setName(name, value);
                    }}
                  />
                </FormGroup>
                <FormGroup controlId="formItemManual-description">
                  {description !== undefined && description !== null && (
                    <FormRichEditor
                      label={messages.description}
                      name={'description_' + index}
                      value={description}
                      onChange={(name, value) => {
                        this.setDescription(name, value);
                      }}
                      id={'formItemManual' + index}
                      key={'formItemManual' + index}
                    />
                    )}
                </FormGroup>
              </Col>
              <Col sm={12} md={6} lg={3}>
                <FormGroup controlId="formItemManual-price">
                  <ControlLabel>{messages.salesDoc.unit_price}</ControlLabel>
                  <FormPriceNetGross netValue={price} vatRate={vat} onChange={this.setPriceValue} currency={'&euro;'} />
                </FormGroup>
              </Col>
              <Col sm={12} md={6} lg={3}>
                <FormGroup controlId="formItemManual-price">
                  <ControlLabel>{user.financial.vat_name || 'MwSt.'}</ControlLabel>
                  <br />
                  <DropdownButton
                    className="no-border bg-transparent"
                    id="quote-vat-rate-dropdown"
                    title={vatTitle}
                    pullRight
                    onSelect={this.setVat}
                  >
                    {vatRateOptions}
                  </DropdownButton>
                </FormGroup>
              </Col>
              <Col sm={12} md={6} lg={3}>
                <FormGroup controlId="formItemManual-price">
                  <ControlLabel>{messages.salesDoc.quantity}</ControlLabel>
                  <FormControl
                    type="number"
                    value={quantity}
                    onChange={this.setQuantity}
                    placeholder={messages.salesDoc.quantity}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Panel.Body>
          <Panel.Footer>
            <Button onClick={this.save} bsStyle="primary">
              {messages.save}
            </Button>
            <Button onClick={this.cancel}>{messages.close}</Button>
          </Panel.Footer>
        </Panel>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

FormItemManual.defaultProps = {
  name: 'items',
};

export default injectIntl(connect(mapStateToProps)(FormItemManual));
